import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"
import { Toast } from "bootstrap"

export default class extends Controller {
  connect() {
    this.fireConfetti()
    this.showToast()
  }

  fireConfetti() {
    confetti({
      particleCount: 120,
      spread: 80,
      origin: { y: 0.6 },
    })
  }

  showToast() {
    const container = this.ensureToastContainer()
    const toastEl = document.createElement("div")
    toastEl.className = "toast align-items-center text-bg-success border-0"
    toastEl.setAttribute("role", "alert")
    toastEl.setAttribute("aria-live", "assertive")
    toastEl.setAttribute("aria-atomic", "true")
    toastEl.innerHTML = `
      <div class="d-flex">
        <div class="toast-body">Improvement! 🎉</div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    `
    container.appendChild(toastEl)

    const toast = new Toast(toastEl, { autohide: true, delay: 3000 })
    toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove())
    toast.show()
  }

  ensureToastContainer() {
    let container = document.getElementById("celebrate-toast-container")
    if (!container) {
      container = document.createElement("div")
      container.id = "celebrate-toast-container"
      container.className = "toast-container position-fixed top-0 end-0 p-3"
      container.style.zIndex = "1080"
      document.body.appendChild(container)
    }
    return container
  }
}
